import styled from "styled-components";

const Clearfix = styled.div`
  clear: both;
`;

export default Clearfix;
